
function introComp(){
    return (
        <div className="intro">

            <div className='first-container'>
            
                <div id='myName'>
                    <h1>Phillip Kataswa</h1>
                </div>

                <div id="skills-cert">

                    <div className='skills'>
                        <h3>Skills</h3>
                        <ul>
                            <li>Languages:</li>
                                <ol><li>Java</li></ol>
                                <ol><li>JavaScript</li></ol>
                                <ol><li>Python</li></ol>

                            <li>Frameworks:</li>
                                <ol><li>ReactJS</li></ol>
                                <ol><li>MaterialUI</li></ol>

                            <li>Tools:</li>
                                <ol><li> Visual Studio</li></ol>
                           
                            <li>Databases:</li>
                                <ol><li> Mysql</li></ol>
                                <ol><li> PostgreSQL</li></ol>
                                <ol><li> MongoDB</li></ol>
                        </ul>

                    </div>

                    <div className='cert'>
                    <h3>Certifications</h3>
                    <ul>
                        <li><a href="https://www.credly.com/badges/95236fa3-9eb5-4662-b378-b01772c3b434/linked_in_profile" rel="noreferrer" target="_blank">AWS Certified Cloud Practitioner</a></li>
                        <li><a href="https://www.hackerrank.com/certificates/00ac2c061cee" rel="noreferrer" target="_blank">MySQL</a></li>
                        <li><a href="https://www.credly.com/badges/30d2dbd4-aff5-412b-867a-0c873f1ce85d/linked_in_profile" rel="noreferrer" target="_blank">Web Development Fundamentals</a></li>
                        <li><a href="https://www.freecodecamp.org/certification/Phillipkataswa/responsive-web-design" rel="noreferrer" target="_blank">Responsive Web Design</a></li>
                    </ul>


                    </div>

                </div>

            </div>

      </div>
    );
}


export default introComp;